/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is used by the internal build
 *   script `extract-intl`, and must use CommonJS module syntax
 *   You CANNOT use import/export in this file.
 */

import queryString from 'query-string';
import esLocaleData from 'react-intl/locale-data/es';
import esTranslationMessages from './translations/es.json';

const addLocaleData = require('react-intl').addLocaleData; //eslint-disable-line
const enLocaleData = require('react-intl/locale-data/en');

const enTranslationMessages = require('./translations/en.json');

addLocaleData(enLocaleData);
addLocaleData(esLocaleData);

const DEFAULT_LOCALE = 'en';

// prettier-ignore
const appLocales = [
    'en',
    'es',
    'es-mx'
];

const formatTranslationMessages = (locale, messages) => {
    const defaultFormattedMessages =
        locale !== DEFAULT_LOCALE
            ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
            : {};
    const flattenFormattedMessages = (formattedMessages, key) => {
        const formattedMessage =
            !messages[key] && locale !== DEFAULT_LOCALE
                ? defaultFormattedMessages[key]
                : messages[key];
        return Object.assign(formattedMessages, { [key]: formattedMessage });
    };
    return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

const translationMessages = {
    en: formatTranslationMessages('en', enTranslationMessages),
    es: formatTranslationMessages('es', esTranslationMessages),
    'es-mx': formatTranslationMessages('es-mx', esTranslationMessages)
};

const getLocale = () => {
    const { lang } = queryString.parse(location.search);
    return (appLocales.indexOf(String(lang).toLowerCase()) !== -1) ?
        String(lang).toLowerCase() : DEFAULT_LOCALE;
};

exports.appLocales = appLocales;
exports.formatTranslationMessages = formatTranslationMessages;
exports.translationMessages = translationMessages;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
exports.getLocale = getLocale;



// WEBPACK FOOTER //
// ./app/i18n.js